import { format, formatDistanceToNowStrict, parseISO } from 'date-fns';

/** Today's `YYYY-MM-DD` in local time (= IST for this India-only project).
 *  Avoid `toISOString().slice(0, 10)` — UTC drifts to tomorrow after 18:30 IST. */
export function todayIso(): string {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

/** Indian-locale rupee amount, e.g. "₹50,000". Returns '—' for null/undefined. */
export function formatRupees(n: number | null | undefined): string {
  if (n == null) return '—';
  return `₹${n.toLocaleString('en-IN')}`;
}

/** Indian-locale integer, e.g. "1,23,456". Returns '—' for null/undefined. */
export function formatIntegerOrDash(n: number | null | undefined): string {
  if (n == null) return '—';
  return n.toLocaleString('en-IN');
}

/** Display-friendly date+time. Returns '—' for null/undefined/invalid input. */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    return format(parseISO(iso), 'dd MMM yyyy, HH:mm');
  } catch {
    return '—';
  }
}

/** Display-friendly date (no time). */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    return format(parseISO(iso), 'dd MMM yyyy');
  } catch {
    return '—';
  }
}

/** Compact relative time, e.g. "2h ago", "3d ago", "5mo ago". */
export function formatRelativeTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    const dist = formatDistanceToNowStrict(parseISO(iso), { addSuffix: false });
    const compact = dist
      .replace(/\s?seconds?$/, 's')
      .replace(/\s?minutes?$/, 'm')
      .replace(/\s?hours?$/, 'h')
      .replace(/\s?days?$/, 'd')
      .replace(/\s?weeks?$/, 'w')
      .replace(/\s?months?$/, 'mo')
      .replace(/\s?years?$/, 'y');
    return `${compact} ago`;
  } catch {
    return '—';
  }
}
